module.exports = __webpack_public_path__ + "img/firstFull.95835118.png";